document.addEventListener('click', (e) => {
  const link = e.target.closest('[data-open-accordion]');
  if (!link) return;

  e.preventDefault();

  const targetLabel = (link.getAttribute('data-open-accordion') || '').trim().toLowerCase();

  // Find the matching <details> by its <summary> text
  const details = Array.from(document.querySelectorAll('details')).find((d) => {
    const s = d.querySelector('summary');
    if (!s) return false;
    return s.textContent.trim().toLowerCase() === targetLabel;
  });

  if (!details) return;

  // Open first
  details.open = true;

  // Then scroll after layout updates
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});